var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("g", [
    _c("g", { attrs: { transform: "translate(0 .09)" } }, [
      _c("path", {
        attrs: {
          d: "M14.5 2.55C7.91 2.55 2.55 7.91 2.55 14.5c0 6.59 5.36 11.95 11.95 11.95 6.59 0 11.95-5.36 11.95-11.95 0-6.59-5.36-11.95-11.95-11.95m0 26.45C6.505 29 0 22.495 0 14.5 0 6.504 6.505 0 14.5 0S29 6.504 29 14.5C29 22.495 22.495 29 14.5 29",
        },
      }),
    ]),
    _vm._v(" "),
    _c("path", {
      attrs: {
        d: "M15 6.657c-4.602 0-8.344 3.743-8.344 8.343 0 4.601 3.742 8.345 8.344 8.345 4.6 0 8.344-3.744 8.344-8.345 0-4.6-3.743-8.343-8.344-8.343M15 25C9.485 25 5 20.514 5 15S9.485 5 15 5c5.514 0 10 4.486 10 10s-4.486 10-10 10",
      },
    }),
    _vm._v(" "),
    _c("g", { attrs: { transform: "translate(23 5.09)" } }, [
      _c("path", {
        attrs: {
          d: "M13.661 49.114L9.18 31.955a1.294 1.294 0 00-1.572-.92c-.687.18-1.1.881-.92 1.57l3.394 12.997c-2.415.328-4.85.326-7.273-.049l3.638-17.998 16.621 12.028a1.288 1.288 0 001.799-.286c4.093-5.646 5.9-12.463 5.164-19.344l.858-.219c2.656 12.725-4.82 25.47-17.228 29.38zm4.463-46.01c4.926 3.949 8.166 9.505 9.17 15.78 1.004 6.271-.338 12.559-3.783 17.843L3.873 22.517 18.124 3.102zM33.09 17.84a1.29 1.29 0 00-1.564-.922l-1.889.48C28.254 10.473 24.374 4.412 18.617.246a1.289 1.289 0 00-1.794.281L1.03 22.039a1.285 1.285 0 00.283 1.802l2.84 2.056L.026 46.332a1.286 1.286 0 001.002 1.514 28.1 28.1 0 005.666.58c1.351 0 2.699-.123 4.042-.32l.766 2.934c.087.33.302.611.595.785a1.292 1.292 0 00.977.135c14.934-3.895 23.913-19.201 20.016-34.12z",
        },
      }),
    ]),
    _vm._v(" "),
    _c("path", {
      attrs: {
        d: "M12 34.597c-4.082 0-7.402 3.322-7.402 7.403 0 4.082 3.32 7.403 7.402 7.403 4.08 0 7.402-3.321 7.402-7.403 0-4.08-3.321-7.403-7.402-7.403M12 52C6.486 52 2 47.515 2 42s4.486-10 10-10 10 4.485 10 10-4.486 10-10 10",
      },
    }),
    _vm._v(" "),
    _c("path", {
      attrs: {
        d: "M12 37.66A4.345 4.345 0 007.66 42 4.344 4.344 0 0012 46.34 4.345 4.345 0 0016.34 42 4.346 4.346 0 0012 37.66M12 48c-3.308 0-6-2.692-6-6s2.692-6 6-6 6 2.692 6 6-2.692 6-6 6M20.112 22a.916.916 0 01-.4-.092c-.934-.451-2.415-1.953-1.332-4.391.19-.429.71-.633 1.166-.45.454.18.666.676.474 1.106-.675 1.522.308 2.13.513 2.237.427.223.593.73.364 1.138a.896.896 0 01-.785.452M8.722 21a.673.673 0 01-.209-.032.743.743 0 01-.483-.917c.248-.867 1.274-2.399 3.383-1.98.393.078.65.469.574.871a.733.733 0 01-.848.591c-1.292-.263-1.662.743-1.725.944a.73.73 0 01-.692.523",
      },
    }),
    _vm._v(" "),
    _c("path", {
      attrs: {
        d: "M11.83 19a.82.82 0 01-.829-.785c-.052-1.714 1.49-2.916 1.666-3.048a.841.841 0 011.162.15.797.797 0 01-.152 1.134c-.292.222-1.042.961-1.018 1.716a.818.818 0 01-.804.833h-.025zM19.251 14c-.1 0-.203-.02-.301-.063-1.891-.818-2.07-2.548-1.9-3.35a.747.747 0 01.886-.57.737.737 0 01.582.863c-.037.198-.156 1.195 1.034 1.71.378.163.551.597.385.97a.75.75 0 01-.686.44M40.956 16.071a1.5 1.5 0 11-.91 2.857 1.5 1.5 0 01.91-2.857M33.957 24.071a1.5 1.5 0 11-.915 2.858 1.5 1.5 0 01.915-2.858M45.956 23.071a1.5 1.5 0 11-.91 2.857 1.5 1.5 0 01.91-2.857M40.07 48.678a1.406 1.406 0 11-.857 2.678 1.406 1.406 0 01.856-2.678M35.956 39.071a1.5 1.5 0 11-.912 2.856 1.5 1.5 0 01.912-2.856M41.957 31.071a1.5 1.5 0 11-.912 2.856 1.5 1.5 0 01.912-2.856M28.957 45.071a1.5 1.5 0 11-.915 2.858 1.5 1.5 0 01.915-2.858",
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }